import React from "react"
import { useLang } from "./i18n/LangContext"
import { PlaceholderImage } from "./PlaceholderImage"

// The "360°" payoff: the growth loop merchants move through, all in one space.
export function GrowthLoopSection() {
  const { t } = useLang()
  const loop = t.growthLoop

  return (
    <section className="bg-white dark:bg-gray-950 py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white text-balance">
            {loop.heading}
          </h2>
          <p className="mt-4 text-gray-500 dark:text-gray-400 max-w-xl mx-auto text-pretty">
            {loop.subheading}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* 360 loop diagram — replace with the real circular graphic later */}
          <PlaceholderImage
            variant="loop"
            aspect="aspect-square"
            label={loop.diagramLabel}
            className="max-w-md mx-auto"
          />

          <ol className="space-y-5">
            {loop.steps.map((step, i) => (
              <li key={i} className="flex gap-4">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-100 dark:bg-brand-900 text-sm font-semibold text-brand-700 dark:text-brand-300">
                  {i + 1}
                </span>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 dark:text-white">{step.title}</h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">{step.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  )
}
